import { render, staticRenderFns } from "./IndustryInformation.vue?vue&type=template&id=61f1d45a&scoped=true"
import script from "./IndustryInformation.vue?vue&type=script&lang=js"
export * from "./IndustryInformation.vue?vue&type=script&lang=js"
import style0 from "./IndustryInformation.vue?vue&type=style&index=0&id=61f1d45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f1d45a",
  null
  
)

export default component.exports